export const utilityColors = {

} as const;
